module.exports = __webpack_public_path__ + "img/noworks.a9884e8.png";